import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Backdrop, Modal } from "@material-ui/core";
import { getVideoEmbedSrc } from "../../utils/constant";

const IframeContainer = ({
  setIsActive,
  setIsHovered,
  videoSrc,
  title,
  isCustomEmbed,
}) => {
  // Check if it's YouTube, regular video, or custom embed
  const isYoutubeUrl = videoSrc.includes("youtube");
  const videoEmbedSrc = getVideoEmbedSrc(videoSrc, isYoutubeUrl, isCustomEmbed);

  // Handle the escape key to close the video
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        setIsActive(false);
        setIsHovered(false);
      }
    };

    document.addEventListener("keydown", handleEscKey);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="video-iframe" onClick={() => setIsActive(false)}>
      <div className="iframe-container">
        {!isCustomEmbed ? (
          <iframe
            width="100%"
            height="0"
            src={videoEmbedSrc}
            title={title}
            frameBorder="0"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        ) : (
          // Render custom embed HTML code directly if provided
          <div dangerouslySetInnerHTML={{ __html: videoSrc }} />
        )}
      </div>
      <img
        src={require("../../assets/images/white-cross.png")}
        className="cross-button"
        alt="close button"
        onClick={(e) => {
          e.stopPropagation();
          setIsActive(false);
          setIsHovered(false);
        }}
      />
    </div>
  );
};

const VideoBox = ({
  videoSrc,
  previewImage,
  playButtonImage,
  playButtonAnimation,
  title,
  innerClassName,
  outerClassName,
  isHoverAnimation,
  isCustomEmbed = false, // new prop to indicate if it's a custom embed
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return (
    <>
      <div className={`video ${outerClassName}`}>
        <div
          className={`video-box ${innerClassName}`}
          onMouseEnter={isHoverAnimation && handleMouseEnter}
          onMouseLeave={isHoverAnimation && handleMouseLeave}
          onClick={() => setIsActive(true)}
          style={{
            cursor: isHoverAnimation ? `url(${playButtonImage}), auto` : "pointer",
          }}
        >
          <div className="content">
            <div className="title">{title}</div>
          </div>

          {previewImage && (
            <img
              src={previewImage}
              alt="video preview"
              // loading="lazy"
              decoding="async"
              className="preview-img"
            />
          )}

          {!isHovered && (
            <img
              className="play-btn"
              src={playButtonImage}
              alt="play button"
              style={{
                animation: playButtonAnimation ? "pulse 1.5s infinite" : "",
              }}
            />
          )}
        </div>
      </div>

      {isActive && (
        <Modal
          open={isActive}
          onClose={() => setIsActive(false)}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <IframeContainer
            setIsActive={setIsActive}
            setIsHovered={setIsHovered}
            videoSrc={videoSrc}
            title={title}
            isCustomEmbed={isCustomEmbed}
          />
        </Modal>
      )}
    </>
  );
};

VideoBox.propTypes = {
  videoSrc: PropTypes.string.isRequired,
  previewImage: PropTypes.string,
  playButtonImage: PropTypes.string,
  title: PropTypes.string,
  innerClassName: PropTypes.string,
  outerClassName: PropTypes.string,
  isHoverAnimation: PropTypes.bool,
  playButtonAnimation: PropTypes.bool,
  isCustomEmbed: PropTypes.bool, // Prop to indicate whether the videoSrc is a custom embed code
};

export default VideoBox;
